import React from 'react';
import { useTranslation } from 'react-i18next';
import '../scss/contact-card.style.scss';

interface ContactCardProps {
    icon: string;
    title: string;
    value: string;
}

export const ContactCard: React.FC<ContactCardProps> = ({ icon, title, value }) => {
    const { t } = useTranslation();
    
    return (
        <div className="contact-card">
            <div className="contact-card-icon-container">
                <img src={icon} alt={t(title)} className="contact-card-icon" />
            </div>
            <div className="contact-card-content">
                <h5 className="contact-card-title">{t(title)}</h5>
                <p className="contact-card-value">{t(value)}</p>
            </div>
        </div>
    );
};
